import React from "react";
import { Table, Button } from "react-bootstrap";
import { IoIosSend } from "react-icons/io";
import moment from "moment";
import { useTheme } from "./ThemeContext";

const StaffTable = ({ groupedStaff, onSend }) => {
  const { isDark } = useTheme();

  return (
    <div className="table-responsive">
      <Table
        bordered
        hover
        className={`mb-0 ${isDark ? "table-dark text-light" : "bg-white text-dark"}`}
      >
        <thead>
          <tr className="text-center">
            <th>No</th>
            <th>Name</th>
            <th>Department</th>
            <th>Supervisor</th>
            <th>Joined Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(groupedStaff).map(([deptName, employees]) => (
            <React.Fragment key={deptName}>
              <tr>
                <td
                  colSpan={6}
                  className={`fw-bold text-start ${
                    isDark ? "bg-secondary text-light" : "bg-light text-dark"
                  }`}
                >
                  {deptName}
                </td>
              </tr>
              {employees.map((emp, index) => (
                <tr key={emp.id} className="align-middle text-center">
                  <td>{index + 1}</td>
                  <td className="text-start">{emp.display_name}</td>
                  <td>{emp.department}</td>
                  <td>{emp.supervisor_name}</td>
                  <td>
                    {emp.date_employed && emp.date_employed !== "0000-00-00"
                      ? moment(emp.date_employed).format("DD-MM-YYYY")
                      : ""}
                  </td>
                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      <Button
                        variant="outline-light"
                        size="sm"
                        style={{
                          color: "#B31E8D",
                          borderColor: "#B31E8D",
                          backgroundColor: isDark ? "#2c2c2c" : "transparent",
                        }}
                        onClick={() => onSend(emp)}
                      >
                        <IoIosSend size={20} /> &nbsp; Send PA Form
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default StaffTable;
